import { Form } from '~/shared/api'
import { requiredRule } from '~/shared/utils/validation'

export default class CalendarSlotDeleteForm extends Form {
  reason: string = ''

  constructor() {
    super()

    this.method = 'POST_AS_DELETE'
    this.setSendAs('form-data')
  }

  static rules() {
    return {
      reason: requiredRule
    }
  }
}
